function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["as", "children", "color", "className", "fixedToRelative", "enabled", "visible", "animation"];
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import styles from "./css/index.css";
var Overlay = function Overlay(_ref) {
  var _cx;
  var ComponentToRender = _ref.as,
    children = _ref.children,
    color = _ref.color,
    className = _ref.className,
    fixedToRelative = _ref.fixedToRelative,
    enabled = _ref.enabled,
    visible = _ref.visible,
    animation = _ref.animation,
    props = _objectWithoutProperties(_ref, _excluded);
  var positionClass = fixedToRelative ? styles['fixed-to-relative'] : styles['fixed-to-page'];
  return /*#__PURE__*/React.createElement(ComponentToRender, _extends({
    className: cx(styles.overlay, styles["color-".concat(color)], positionClass, className, (_cx = {}, _defineProperty(_cx, styles['not-enabled'], !enabled), _defineProperty(_cx, styles['not-visible'], !visible), _defineProperty(_cx, styles.animated, animation), _cx))
  }, props), children);
};
process.env.NODE_ENV !== "production" ? Overlay.propTypes = {
  as: PropTypes.elementType,
  /**
   * Element/content to render in the Overlay
   */
  children: PropTypes.node,
  /**
   * The color theme of the overlay
   */
  color: PropTypes.oneOf(['light', 'dark']),
  /**
   * Additional classes to be used
   */
  className: PropTypes.string,
  /**
   * Whether or not to position the overlay within a relative
   */
  fixedToRelative: PropTypes.bool,
  /**
   * Whether or not the overlay is enabled. This is useful when the overlay is animated and must be always mounted.
   *
   * When false, it disabled the ability to click on anything in the overlay and visually hides the overlay
   */
  enabled: PropTypes.bool,
  /**
   * Whether or not the overlay is visible. This is useful when the overlay is animated and must be always mounted
   *
   * Unlike `enabled`, this prop only influences whether the overlay is visible, but still allows the contents
   * of the overlay to be interactive
   */
  visible: PropTypes.bool,
  /**
   * Allow animated styles on the Overlay
   */
  animation: PropTypes.bool
} : void 0;
Overlay.defaultProps = {
  as: 'aside',
  color: 'dark',
  className: '',
  fixedToRelative: false,
  enabled: true,
  visible: true,
  animation: true
};
export default Overlay;